import {
  Accordion,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  IconButton,
  useBreakpointValue,
  UseDisclosureReturn,
  VStack,
} from "@chakra-ui/react";

import { ShiIcon } from "src/atoms";
import { Link } from "src/atoms/PrismicLink";
import ShiButton from "src/atoms/ShiButton";
import HeaderAccordionItem from "./HeaderAccordionItem";
import { onClickNewAccount } from "src/lib/event";
import useVisitorContext from "src/providers/VisitorContext/useVisitorContext";
import { useLocation } from "@reach/router";
import { ClickInfo } from "src/lib/event/types";

import { FC, Fragment } from "react";

import { HeaderSection } from "../types";

type MobileDrawerProps = Pick<UseDisclosureReturn, "isOpen" | "onClose"> & {
  data: Gatsby.SiteNavbarV2Fragment["data"];
  headerSections: HeaderSection[];
};

const MobileDrawer: FC<MobileDrawerProps> = ({
  isOpen,
  onClose,
  data,
  headerSections,
}) => {
  if (!data) throw Error();

  const size = useBreakpointValue({ base: "full", sm: "md" });
  const visitorContext = useVisitorContext();
  const location = useLocation();

  return (
    <Drawer isOpen={isOpen} onClose={onClose} size={size} placement="top">
      <DrawerOverlay />
      <DrawerContent
        borderBottomRadius="lg"
        height="auto"
        maxHeight="100dvh"
        sx={{
          bottom: "initial !important",
        }}
      >
        <DrawerHeader
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          paddingY="space-8"
          paddingX="space-16"
        >
          <IconButton
            aria-label="Shine logo"
            variant="ghost"
            marginRight="space-24"
            marginLeft="2px"
            icon={
              <ShiIcon
                name="ShineLogo"
                width={{ base: "70px" }}
                height="auto"
              />
            }
          />
          <DrawerCloseButton
            size="md"
            position="unset"
            sx={{
              svg: {
                width: "12px",
                height: "12px",
              },
            }}
          />
        </DrawerHeader>

        <DrawerBody
          display="flex"
          flexDirection="column"
          justifyContent="flex-start"
          paddingX="space-16"
          paddingY="space-32"
        >
          <Accordion
            textAlign="left"
            width="100%"
            allowToggle
            sx={{
              "> :first-of-type": {
                borderTop: "none",
              },
              "> .chakra-link": {
                display: "block",
                paddingY: "space-16",
              },
            }}
          >
            {headerSections?.map((section) => {
              if (!section || !section.primary) return;

              return (
                <Fragment key={section.id}>
                  <HeaderAccordionItem key={section.id} section={section!} />
                </Fragment>
              );
            })}
          </Accordion>
          <VStack
            mt="space-32"
            spacing="space-24"
          >
            <ShiButton
              onClick={(e) => {
                const clickInfo: ClickInfo = {
                  label: data.start_label,
                  platform: 'web-mobile',
                  block: 'site_navbar',
                  fromLocation: location
                };

                onClickNewAccount(e, visitorContext, clickInfo)
              }}
              variant="primary"
              size="md"
              hasArrow
            >
              {data.start_label}
            </ShiButton>

            <Button
              as={Link}
              variant="secondary"
              paddingBottom="0"
              border="none"
              href="https://app.shine.fr/"
            >
              {data.login_label}
            </Button>
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default MobileDrawer;
